import React, { useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Navigation } from 'swiper'
import SwiperButton2 from 'Components/swiper-button2'
import { Image } from 'Components/view-image'
import classNames from 'classnames'
import {
  preventDefault,
  stopPropagation,
} from 'Components/new/community-card/interact'

SwiperCore.use([Navigation])

interface IVProps {
  imgList: string[]
  activeIndex?: number
  onClick?: () => void
}

interface ICProps {
  imgList: string[]
  onClick?: (idx: number) => void
  activeIndex?: number
}

const ImageCandidates = (props: ICProps) => {
  const { imgList = [], onClick, activeIndex = 0 } = props

  return imgList.length > 1 ? (
    <div className="tw-pt-8 tw-grid tw-grid-cols-9 tw-gap-8">
      {imgList.map((e, index) => (
        <div
          className={classNames('tw-relative tw-h-66', {
            active: activeIndex === index,
          })}
          key={e + index}
          onClick={(e: React.MouseEvent) => {
            e.preventDefault()
            e.stopPropagation()
            onClick && onClick(index)
          }}
        >
          <Image
            width={160}
            height={66}
            src={e}
            layout={'fill'}
            className="tw-bg-black tw-cursor-pointer"
          />
        </div>
      ))}
      <style jsx>
        {`
          .active::before {
            content: '';
            width: calc(100% + 8px);
            height: 74px;
            border: #ffcc32 4px solid;
            position: absolute;
            top: -4px;
            left: -4px;
          }
        `}
      </style>
    </div>
  ) : null
}

export function isAdjacent(
  index: number,
  target: number,
  length: number,
  offset = 1
) {
  return (
    Math.abs(index - target) <= offset ||
    Math.abs(index + length - target) <= offset ||
    Math.abs(index - length - target) <= offset
  )
}

const ImageViewer = (props: IVProps) => {
  const { imgList = [], activeIndex = 0, onClick } = props
  const [indexNow, setIndexNow] = useState(activeIndex)
  const [swiper, setSwiper] = useState<any>(null)

  const handleSelect = (idx: number) => {
    setIndexNow(idx)
    if (swiper && swiper.slideTo) {
      swiper.slideToLoop(idx)
    }
  }

  useEffect(() => {
    setIndexNow(activeIndex)
  }, [activeIndex])

  const [prevEl, setPrevEl] = useState<HTMLElement | null>(null)
  const [nextEl, setNextEl] = useState<HTMLElement | null>(null)

  return imgList.length ? (
    <div className="image-viewer" onClick={stopPropagation(preventDefault())}>
      <div className="swiper-transition-wrapper">
        <Swiper
          loop={imgList.length > 1}
          simulateTouch={false}
          watchOverflow={true}
          navigation={{
            nextEl,
            prevEl,
          }}
          onSwiper={setSwiper}
          onSlideChange={(swiper) => {
            setIndexNow(swiper.realIndex)
          }}
          initialSlide={activeIndex}
        >
          {imgList.map((e, index) => (
            <SwiperSlide key={e + index}>
              <Image
                width={1000}
                height={650}
                layout="responsive"
                objectFit="contain"
                src={e}
                onClick={onClick}
                className="tw-cursor-zoom-out tw-bg-black"
                lazy={!isAdjacent(index, indexNow, imgList.length)}
              />
            </SwiperSlide>
          ))}
        </Swiper>
        <div className={imgList.length > 1 ? 'tw-block' : 'tw-hidden'}>
          <SwiperButton2 type={'prev'} ref={setPrevEl} />
          <SwiperButton2 type={'next'} ref={setNextEl} />
        </div>
      </div>
      <ImageCandidates
        imgList={imgList}
        onClick={handleSelect}
        activeIndex={indexNow}
      />
    </div>
  ) : null
}

export default ImageViewer
